export interface TaskQueryRequest {
  page?: number;
  limit?: number;
  sort?: ApplicationSortSetting[];
  stage?: string[];
  lifeCycle?: string[];
  taskType?: string[];
  taskState?: string[];
  carrier?: string[];
}

export interface ApplicationSortSetting {
  field: string;
  asc: boolean;
}

export enum TaskSort {
  CreatedAt = 'created_at',
  LifeCycle = 'life_cycle',
  Stage = 'stage',
  Sla = 'sla',
  TermPolicyId = 'termPolicyId',
}
